<div class="row mb-3 mt-2">
    <div class="col">
        <span class="tittlePayments">{{titleP}}</span>
    </div>
</div>
